import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";

import { ALLOWED_MODULES } from "../../constants/enums";

const ManageComponyInformation = Loadable(
	lazy(() =>
		import("./CompanyInformation").then(({ CompanyInformation }) => ({
			default: CompanyInformation,
		}))
	)
);

export const componyInformationRoutes = [
	{
		path: "/company-information",
		exact: true,
		element: (
			<AuthorizedRoute
				moduleIds={[ALLOWED_MODULES.COMPANY_INFORMATION]}
			>
				<ManageComponyInformation />
			</AuthorizedRoute>
		),
	},
];
